<footer class="d-flex align-items-center justify-content-center flex-column flex-md-row">
    <div>
        <small>{{text?.reCaptchaAlert.message}}</small>
    </div>
    <div>
        <small><a href="https://www.google.com/intl/iw/policies/privacy/">{{text?.reCaptchaAlert.private}}</a></small>
        <small>{{text?.reCaptchaAlert.and}}-</small>
        <small><a href="https://www.google.com/intl/iw/policies/terms/">{{text?.reCaptchaAlert.service}}</a></small>
        <small>{{text?.reCaptchaAlert.end}}</small>
    </div>
</footer>